import React from 'react'
import PropTypes from 'prop-types'
import { TextInput } from '@jisr-hr/design-system'
import I18n from 'translations/i18n'

const Input = ({ meta: { touched, error }, input, label, testId, style, ...props }) => (
  <TextInput
    status={error && touched && 'error'}
    statusMessage={error}
    style={{ marginBottom: 8, ...style }}
    {...props}
    {...input}
    label={label && I18n.t(label)}
    data-testid={testId}
    onWheel={(e) => e.target.blur()}
  />
)

Input.propTypes = {
  label: PropTypes.string,
  testId: PropTypes.string,
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  style: PropTypes.shape(),
}

export default Input
